import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';

export const DEFAULT_PRECHAT_MESSAGE =
  '<h1 class="font-bold">👋 Welcome to our chat!</h1><p class="leading-none my-[10px]">---</p><p class="leading-none my-[10px]">We\'re here to assist you!</p><p class="leading-none my-[10px]">Click the button below to start a conversation and get the help you need.</p><h2 class="font-bold">🚀 How it works:</h2><p class="leading-none my-[10px]">- Ask any question, and we\'ll do our best to assist you.</p><p class="leading-none my-[10px]">- Get quick responses and helpful information.</p><p class="leading-none my-[10px]">- Enjoy a smooth and friendly chat experience.</p><p class="leading-none my-[10px]">---</p><p class="leading-none my-[10px]">👇 Click the button below to begin!</p>';

export const buildPrimaryFormValues = (
  data: WidgetSettingsDto,
  t: (key: string) => string,
): WidgetSettingsDto => ({
  ...data,
  conversation_starters: data.conversation_starters ?? [],
  background_disclaimer_text:
    data.background_disclaimer_text ?? t('background_disclaimer_text.placeholder'),
  prechat_header_text: data.prechat_header_text ?? '',
  prechat_button_text: data.prechat_button_text ?? 'Start Chatbot',
  prechat_message_text: data.prechat_message_text ?? DEFAULT_PRECHAT_MESSAGE,
});
